/** @jsx jsx **/
import { jsx } from "@emotion/react";

import * as styles from "./Notice.style";

export default function Notice() {
  return (
    <div css={styles.container}>
      <div css={styles.textContainer}>
        <h1>이제 자유로운 여행을 떠날 수 있어요!</h1>
        <p>
          코로나19 관련 입국 제한 조치가 완화됨에 따라 <br />
          ‘격리 없는 여행지’ 서비스가 종료되었습니다.
        </p>
      </div>
      <div css={styles.buttonContainer}>
        <a css={styles.button} href="https://www.myrealtrip.com">
          <span>메인 홈으로 이동</span>
        </a>
      </div>
    </div>
  );
}
